<header>
  <div class="container-width">
    <!-- Header Left Section -->
    <div class="header-left">
      <!-- <mbsc-button
      *ngIf="showSidebarButton"
      class="sidebar-btn"
      icon="material-menu"
      (click)="onToggleSidebar()">
    </mbsc-button> -->

    <img
      (click)="reloadPage()"
      loading="lazy"
      loading="eager"
      class="logo"
      src="./assets/logo/tridimo_logo.svg"
      alt="logo" />
    </div>

    <!-- Popup for Advanced Search Help -->
    <mbsc-popup #popup [anchor]="popupAnchor" [options]="popupOptions" (onClose)="onClose()" (onDestroy)="onDestroy()" (onInit)="onInit()" (onOpen)="onOpen()" (onPosition)="onPosition()">
      <div class="mbsc-align-center mbsc-padding text-left" style="font-size: 1.1em; line-height: 1.6;">

        <p>
          Mit der erweiterten Suche kannst du Termine gezielt filtern.<br>
          Verwende dazu:
        </p>

        <ul style="padding-left: 25px;">
          <li><b>Klammern ( )</b> – um Bedingungen zu gruppieren</li>
          <li><b>AND</b> – für <i>UND</i>-Verknüpfungen</li>
          <li><b>OR</b> – für <i>ODER</i>-Verknüpfungen</li>
          <li><b>Feldname=Wert</b> – um nach bestimmten Eigenschaften zu suchen</li>
          <li><b>start / end</b> akzeptieren auch Zeitvergleiche: <code>>=</code>, <code><=</code></li>
        </ul>

        <hr>

          <h3 style="font-size: 1.3em; margin-top: 20px;">📌 Event-Felder</h3>
          <div style="columns: 2; font-size: 1em;">
            <ul>
              <li><code>id</code></li>
              <li><code>start</code></li>
              <li><code>end</code></li>
              <li><code>titel</code></li>
              <li><code>ort</code></li>
              <li><code>kategorie</code></li>
              <li><code>typ</code></li>
              <li><code>ticketnr</code></li>
            </ul>
            <ul>
              <li><code>online</code></li>
              <li><code>minutengenau</code></li>
              <li><code>einwahlzeit</code></li>
              <li><code>status</code></li>
              <li><code>farbe</code></li>
            </ul>
          </div>

          <hr>

            <h3 style="font-size: 1.3em; margin-top: 20px;">📌 Kunden-Felder</h3>
            <div style="columns: 2; font-size: 1em;">
              <ul>
                <li><code>kunde.email</code></li>
                <li><code>kunde.vorname</code></li>
                <li><code>kunde.nachname</code></li>
                <li><code>kunde.unternehmen</code></li>
              </ul>
              <ul>
                <li><code>kunde.ort</code></li>
                <li><code>kunde.plz</code></li>
                <li><code>kunde.telefon</code></li>
                <li><code>kunde.mobil</code></li>
              </ul>
            </div>

            <hr>

              <h3 style="font-size: 1.3em; margin-top: 20px;">✅ Beispiele</h3>
              <p style="font-size: 1em;">

                <b>🔎 Titel & ID</b><br>
                <code>(titel=Besprechung AND id=12)</code><br>
                → Suche nach Termin mit Titel "Besprechung" und ID 12<br><br>

                <b>🔎 Ort oder Kategorie</b><br>
                <code>(ort=Berlin OR kategorie=Konferenz)</code><br>
                → Termine in Berlin oder mit Kategorie Konferenz<br><br>

                <b>🔎 Online-Termine</b><br>
                <code>(online=1)</code><br>
                → Nur Online-Termine<br><br>

                <b>🔎 Datumsbereich</b><br>
                <code>(start>=2026-01-01T00:00:00 AND start<=2026-01-31T23:59:59)</code><br>
                → Termine im Januar 2026<br><br>

                <b>🔎 Kundendaten</b><br>
                <code>(kunde.vorname=Marion AND kunde.plz=10115)</code><br>
                → Termine für Kunde "Marion" aus PLZ 10115<br><br>
              </p>

              <hr>

                <h3 style="font-size: 1.3em; margin-top: 20px;">
                  📘
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dolmetscher.sharepoint.com/sites/Tridimo-Team/_layouts/Doc.aspx?sourcedoc={54C6EC20-7BAB-4C36-B9D3-651DB688B4D4}&wd=target%28Technik.one%7CBE43856E-D3E5-4FBB-896A-0BACAF6F50CF%2FKalender%20Erweiterte%20Suche%7C93D490D6-BADA-4695-84F7-1CA70A27CE6D%2F%29&wdpartid={666298D0-D0CC-058E-2892-525ECDB9A73D}{1}&wdsectionfileid={CD0382AB-64A5-4740-8D3C-9D71EA3ACD49}">
                    Dokumentation ansehen
                  </a>
                </h3>
              </div>
            </mbsc-popup>


            <!-- Header Middle Section - Search -->
            <div class="header-middle">
              @if (currentUrl.includes('search-event-view') || currentUrl.includes('search-advanced-event-view')) {
                <mbsc-button
                  class="info-btn"
                  title="Beispeile für erweiterte Suche"
                  (click)="openPopup($event)">
                  i
                </mbsc-button>
              }

              @if (currentUrl.includes('admin-calendar') || currentUrl.includes('search-event-view') || currentUrl.includes('search-advanced-event-view')) {
                <div
                  class="search-input-container">
                  <c-input-group class="input-group">
                    <input
                      aria-describedby="button-addon2"
                      aria-label="Termin suchen... (min. 4 Zeichen)"
                      cFormControl
                      [placeholder]="searchPlaceholder"
                      class="event-input form-control"
                      [(ngModel)]="eventSearchInput"
                      (input)="onInput($event)"
                      #searchInput
                      type="text"
                      (keydown.enter)="openEventSearch()" />
                      @if (currentUrl.includes('admin-calendar')) {
                        <button
                          [ngClass]="themeService.isDarkMode ? 'darkmode' : ''"
                          cButton
                          color="secondary"
                          class="input-filter-btn"
                          (click)="openEventFilter()"
                          #eventFilterButton
                          [disabled]="(!eventSearchInput || eventSearchInput.length < 4)">
                          <svg class="filter-svg" [cIcon]="icons.cilFilter" size="lg"></svg>
                        </button>
                      }
                      <button
                        [ngClass]="themeService.isDarkMode ? 'darkmode' : ''"
                        cButton
                        color="secondary"
                        class="input-search-btn"
                        (click)="openEventSearch()"
                        [disabled]="!eventSearchInput || eventSearchInput.length < 4">
                        <svg class="search-svg" [cIcon]="icons.cilSearch" size="lg"></svg>
                      </button>
                    </c-input-group>
                  </div>
                }
              </div>

              <!-- Header Right Section - Navigation Dropdowns -->
              <div class="header-right">

                <!-- Event Fehler -->
                <c-header-nav style="gap: 14px;" class="header-nav ms-auto ms-md-0 dropdown" role="navigation">
                  @if (isAdminCalendar && (this.UserRole === 'Personal' || this.UserRole === 'Admin' || this.UserRole === 'Buero')) {
                    <div class="nav-item py-1">
                      <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
                    </div>
                  }

                  @if (errorFilterActive) {
                    <button (click)="resetErrorFilter()" type="button" class="error-filter-active-button" title="Filter löschen">
                      <div style="height: 10px; width: 10px; background-color: rgba(var(--cui-danger-rgb)); border-radius: 50%;"></div>
                      <span>Fehlerfilter aktiv:</span>
                      <span>{{ filterName }}</span>
                    </button>
                  }


                  @if (isAdminCalendar && (this.UserRole === 'Personal' || this.UserRole === 'Admin' || this.UserRole === 'Buero')) {
                    <c-dropdown alignment="end">
                      <button cDropdownToggle type="button" class="position-relative border-0 bg-transparent">
                        @if (allErrors > 0) {
                          <c-badge color="danger" shape="rounded-pill" class="notification-badge" position="top-end">
                            {{ allErrors }}
                          </c-badge>
                        }
                        <div class="info-icon"  [innerHTML]="this.svgIconService.svgCache['glocke']"></div>
                      </button>
                      <!-- CONTENT -->
                      @if (eventsWithErrors?.meta; as meta) {
                        <ul cDropdownMenu class="error-container">
                          <!-- HEADER -->
                          <div class="error-popup-main-header-container">
                            <div>
                              <div class="error-popup-main-header-title">Terminprüfung</div>
                              <div>Übersicht der Datenqualität und fehlender Angaben</div>
                            </div>
                            <div>
                              <div>Letzte Prüfung,</div>
                              <div>{{lastErrorCheck}}</div>
                            </div>
                          </div>
                          <!-- FEHLER ZUSAMMENFASSUNG -->
                          <div class="error-summary-container"
                            [ngStyle]="{'background-color': totalWithErrors > 0 ? 'rgba(255, 0, 0, 0.05)' : 'rgba(0, 128, 0, 0.15)'}"
                            >
                            @if (totalWithErrors > 0) {
                              <div class="warn-icon" [style.color]="'red'" [innerHTML]="svgIconService.svgCache['warn']"></div>
                            }
                            @if (totalWithErrors === 0) {
                              <div class="check-icon" [style.color]="'green'" [innerHTML]="svgIconService.svgCache['check']"></div>
                            }
                            <div>
                              <div>
                                <span class="error-summary-values">{{ totalWithErrors }} von {{ totalFetched }} Terminen</span>
                                <span class="error-summary-span" > haben Handlungsbedarf</span>
                              </div>
                              <div>Insgesamt wurden <span class="error-summary-values">{{allErrors}} Probleme</span> gefunden </div>
                            </div>
                          </div>
                          <!-- BEARBEITUNGSSTATUS -->
                          @if (totalNotChecked > 0 || totalErrorStatus > 0 || totalErrorBacklog > 0) {
                            <div class="header-container">
                              <div class="header-icon-container">
                                <div class="header-icon" [innerHTML]="svgIconService.svgCache['clipboard']"></div>
                                <div class="header-container-header">Bearbeitungsstatus</div>
                              </div>
                              <div class="header-container-info">Nur geprüfte und gebuchte Termine gelten als vollständig.</div>
                            </div>
                          }
                          <!-- NICHT GEPRÜFT -->
                          @if (totalNotChecked > 0) {
                            <div class="check-container" (click)="getEventsToFilter('eventsNotChecked')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['check']"></div>
                                <div class="check-title">Termine geprüft</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress  class="progress-line"
                                  [value]="((totalFetched - totalNotChecked)/ totalNotChecked) * 100"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ totalFetched - totalNotChecked }} / {{ totalFetched }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalNotChecked === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalNotChecked === 0 ? 'green' : 'red',
                    }">{{ totalNotChecked }}
                                </div>
                                nicht geprüft
                              </div>
                            </div>
                            <hr style="margin: 0px 8px;">
                          }
                          <!-- NICHT GEBUCHT -->
                          @if (totalErrorStatus > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorStatus')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['cart']"></div>
                                <div class="check-title">Noch reserviert (nicht gebucht)</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress
                                  class="progress-line"
                    [value]="totalFetched > 0 
                      ? (totalErrorStatus / totalFetched) * 100 
                      : 0"
                                  color="danger"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ totalErrorStatus }} / {{ totalFetched }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalErrorStatus === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalErrorStatus === 0 ? 'green' : 'red',
                    }">{{ totalErrorStatus }}
                                </div>
                                noch zu buchen
                              </div>
                            </div>
                            <hr style="margin: 0px 8px;">
                          }
                          <!-- BACKLOG -->
                          @if (totalErrorBacklog > 0) {
                            <div class="check-container">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['liste']"></div>
                                <div class="check-title">Termine im Backlog</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                                  [value]="totalFetched > 0 ? (totalErrorBacklog / totalFetched) * 100 : 0"
                                  color="danger"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ totalErrorBacklog }} / {{ totalFetched }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalErrorBacklog === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalErrorBacklog === 0 ? 'green' : 'red',
                    }">{{ totalErrorBacklog }}</div> im Backlog
                              </div>
                            </div>
                          }
                          <!-- ADRESSE -->
                          @if (totalAddressMissing > 0 || totalAddressInvalidFormat > 0) {
                            <div class="header-container">
                              <div class="header-icon-container">
                                <div class="header-icon" [innerHTML]="svgIconService.svgCache['location']"></div>
                                <div class="header-container-header">Adresse</div>
                              </div>
                              <div class="header-container-info">Jeder Termin benötigt eine gültige Adresse.</div>
                            </div>
                          }
                          <!-- ADRESSE VORHANDEN -->
                          @if (totalAddressMissing > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorAddressMissing')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['houseCheck']"></div>
                                <div class="check-title">Adresse vorhanden</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="eventsWithErrors.meta.totalFetched > 0
                    ? ( (totalFetched - totalAddressMissing) / totalFetched ) * 100
                    : 0"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ eventsWithErrors.meta.totalFetched - totalAddressMissing }}
                                  / {{ eventsWithErrors.meta.totalFetched }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalAddressMissing === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalAddressMissing === 0 ? 'green' : 'red',
                    }">{{ totalAddressMissing }}</div> fehlende Adresse
                              </div>
                            </div>
                            <hr style="margin: 0px 8px;">
                          }
                          <!-- ADRESSE IM RICHTIGEN FORMAT -->
                          @if (totalAddressInvalidFormat > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorAddressInvalid')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['formatCheck']"></div>
                                <div class="check-title">Adresse im richtigen Format</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="totalFetched > 0
                    ? ((totalFetched - totalAddressInvalidFormat) / totalFetched) * 100
                    : 0"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value"> {{ totalFetched - totalAddressInvalidFormat }} / {{ totalFetched }}</div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalAddressInvalidFormat === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalAddressInvalidFormat === 0 ? 'green' : 'red',
                    }">{{ totalAddressInvalidFormat }}</div> falsches Format
                              </div>
                            </div>
                          }
                          <!-- ONLINE-LINK -->
                          @if (totalOnlineLinkMissing > 0) {
                            <div class="header-container">
                              <div class="header-icon-container">
                                <div class="header-icon" [innerHTML]="svgIconService.svgCache['link']"></div>
                                <div class="header-container-header">Online-Link</div>
                              </div>
                              <div class="header-container-info">Für Online-Termine ist ein gültiger Link erforderlich.</div>
                            </div>
                          }
                          <!-- ONLINE LINK VORHANDEN -->
                          @if (totalOnlineLinkMissing > 0 || totalOnlineLinkInvalid > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorOnlineLinkMissing')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['link']"></div>
                                <div class="check-title">Online-Link vorhanden</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="totalOnlineEvents > 0
                    ? ((totalOnlineEvents - totalOnlineLinkMissing) / totalOnlineEvents) * 100
                    : 0"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value"> {{ totalOnlineEvents - totalOnlineLinkMissing }} / {{ totalOnlineEvents }}</div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalOnlineLinkMissing === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalOnlineLinkMissing === 0 ? 'green' : 'red',
                    }">{{ totalOnlineLinkMissing }}</div> fehlender Link
                              </div>
                            </div>
                            <hr style="margin: 0px 8px;">
                          }
                          <!-- ONLINE LINK IM RICHTIGEN FORMAT -->
                          @if (totalOnlineLinkInvalid > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorOnlineLinkInvalid')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['linkBroken']"></div>
                                <div class="check-title">Online-Link im richtigen Format</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="(totalOnlineEvents - totalOnlineLinkMissing) > 0
                      ? (  (totalOnlineEvents - totalOnlineLinkMissing - totalOnlineLinkInvalid) / (totalOnlineEvents - totalOnlineLinkMissing)) * 100
                      : 0"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ totalOnlineEvents - (totalOnlineLinkMissing + totalOnlineLinkInvalid) }}
                                  / {{ totalOnlineEvents - totalOnlineLinkMissing}}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalOnlineLinkInvalid === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalOnlineLinkInvalid === 0 ? 'green' : 'red',
                    }">{{ totalOnlineLinkInvalid }}</div> falsches Format
                              </div>
                            </div>
                          }
                          <!-- WEITERE ANGABEN -->
                          @if (totalErrorTicketNo > 0 || totalErrorVbMaterialMissing > 0 || totalErrorInterpreter > 0) {
                            <div class="header-container">
                              <div class="header-icon-container">
                                <div class="header-icon" [innerHTML]="svgIconService.svgCache['file']"></div>
                                <div class="header-container-header">Weitere Angaben</div>
                              </div>
                              <div class="header-container-info">Zusätzliche Informationen für die Durchführung.</div>
                            </div>
                          }
                          <!-- TICKETNUMMER VORHANDEN -->
                          @if (totalErrorTicketNo > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorTicketMissing')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['ticket']"></div>
                                <div class="check-title">Ticketnummer vorhanden</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="totalFetched > 0 
                    ? ((totalFetched - totalErrorTicketNo) / totalFetched) * 100 
                    : 0"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ totalFetched - totalErrorTicketNo }} / {{ totalFetched }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalErrorTicketNo === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalErrorTicketNo === 0 ? 'green' : 'red',
                    }">{{ totalErrorTicketNo }}</div> fehlende Ticketnummer
                              </div>
                            </div>
                            <hr style="margin: 0px 8px;">
                          }
                          <!-- VORBEREITUNGSMATERIAL -->
                          @if (totalErrorVbMaterialMissing > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorVbMissing')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['vbm']"></div>
                                <div class="check-title">Vorbereitungsmaterial</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="eventsWithErrors.meta.totalEventsmitVB > 0
                    ? (eventsWithErrors.meta.totalEventsmitVB - totalErrorVbMaterialMissing / eventsWithErrors.meta.totalEventsmitVB) * 100
                    : 0"
                                  color="danger"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ eventsWithErrors.meta.totalEventsmitVB - totalErrorVbMaterialMissing }}
                                  / {{ eventsWithErrors.meta.totalEventsmitVB }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalErrorVbMaterialMissing === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalErrorVbMaterialMissing === 0 ? 'green' : 'red',
                    }">{{ totalErrorVbMaterialMissing }}</div> fehlendes Material
                              </div>
                            </div>
                            <hr style="margin: 0px 8px;">
                          }
                          <!-- DOLMETSCHER ZUGEORDNET -->
                          @if (totalErrorInterpreter > 0) {
                            <div class="check-container" (click)="getEventsToFilter('errorInterpreter')">
                              <div class="check-title-icon-container">
                                <div class="title-icon" [innerHTML]="svgIconService.svgCache['users']"></div>
                                <div class="check-title">Dolmetscher zugeordnet</div>
                              </div>
                              <div class="progress-value-container">
                                <c-progress class="progress-line"
                    [value]="totalFetched > 0 
                    ? ((totalFetched - totalErrorInterpreter) / totalFetched) * 100 
                    : 0"
                                  color="success"
                                  [height]="10">
                                </c-progress>
                                <div class="check-value">
                                  {{ totalFetched - totalErrorInterpreter }} / {{ totalFetched }}
                                </div>
                              </div>
                              <div class="rest-container">
                                <div class="rest-value"
                    [ngStyle]="{
                      'background-color': totalErrorInterpreter === 0 ? 'rgba(0, 128, 0, 0.15)' : 'rgba(255, 0, 0, 0.15)',
                      'color': totalErrorInterpreter === 0 ? 'green' : 'red',
                    }">{{ totalErrorInterpreter }}</div> fehlende Dolmetscher
                              </div>
                            </div>
                          }
                          <!-- ABSCHLUSS INFO -->
                          <div class="info-container">
                            <div class="title-icon" [innerHTML]="svgIconService.svgCache['circleInfo']"></div>
                            <div class="header-container-info">Ein Termin kann mehrere Probleme haben. Die Anzahl der Probleme ist daher höher als die Anzahl der Termine.</div>
                          </div>
                        </ul>
                      }
                    </c-dropdown>
                  }

                  @if (isAdminCalendar && (this.UserRole === 'Personal' || this.UserRole === 'Admin' || this.UserRole === 'Buero')) {
                    <c-dropdown class="dropdown" alignment="end">
                      <button
                        cDropdownToggle
                        type="button"
                        style="border: none; background: transparent; position: relative;"
                        >
                        <div class="info-icon"  [ngClass]="themeService.isDarkMode ? 'darkmode' : ''" [innerHTML]="this.svgIconService.svgCache['liste']"></div>
                      </button>
                      @if (eventsWithErrors?.events; as meta) {
                        <ul cDropdownMenu style="max-height: 400px; overflow-y: scroll; width: 500px;">
                          <li>
                            <h6 cDropdownHeader class="dropdown-header bg-body-secondary text-body-secondary fw-semibold my-2">
                              {{ totalWithErrors }} Termine
                            </h6>
                          </li>
                          <li>
                            <mbsc-eventcalendar
                              [data]="eventsWithErrors.events"
                              [view]="listView"
                              (onEventClick)="onEventWithErrorClick($event)"
                              [showControls]="false"
                              [eventTemplate]="mbsc_event"
                              >
                              <ng-template #mbsc_event let-event>
                                <app-event-view-notifications
                                  style="width: 100%;"
                                  [event]="event"
                                ></app-event-view-notifications>
                              </ng-template>
                            </mbsc-eventcalendar>
                          </li>
                        </ul>
                      }
                    </c-dropdown>
                  }

                  @if (isAdminCalendar && (this.UserRole === 'Personal' || this.UserRole === 'Admin' || this.UserRole === 'Buero')) {
                    <div class="nav-item py-1">
                      <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
                    </div>
                  }

                  @if (smallTabView) {
                    <button type="button" style="border: none; background: transparent; position: relative;" (click)="toggleSidebar()">
                      <div class="info-icon"  [innerHTML]="this.svgIconService.svgCache['burger_menu']"></div>
                    </button>
                  }
                </c-header-nav>

                <!-- Navigation Großer Bildschirm -->
                @if (!smallTabView) {
                  <c-header-nav class="header-nav ms-auto ms-md-0" role="navigation">
                    @if (this.UserRole === 'Personal' || this.UserRole === 'Admin') {
                      <c-dropdown alignment="end">
                        <button
                          class="big-screen-nav-btn"
                          cDropdownToggle
                          type="button"
                          style="border: none; background: transparent; position: relative;"
                          >
                          Personal
                        </button>
                        <ul cDropdownMenu>
                          <li>
                            <a (click)="navigateTo('annual-overview-admin')" class="dropdown-item">Jahresübersicht</a>
                          </li>
                          <li>
                            <a (click)="navigateTo('timesheet')" class="dropdown-item">Stundenliste</a>
                          </li>
                        </ul>
                      </c-dropdown>
                    }
                    @if (this.UserRole === 'Admin' || this.UserRole === 'Buero') {
                      <c-dropdown alignment="end">
                        <button
                          class="big-screen-nav-btn"
                          cDropdownToggle
                          type="button"
                          style="border: none; background: transparent; position: relative;"
                          >
                          Planung
                        </button>
                        <ul cDropdownMenu>
                          <li>
                            <a (click)="navigateTo('admin-calendar')" class="dropdown-item">Kalender</a>
                          </li>
                          <li>
                            <a (click)="navigateTo('blocker-calendar')" class="dropdown-item">Blocker Kalender</a>
                          </li>
                        </ul>
                      </c-dropdown>
                    }
                    @if (this.UserRole === 'Admin' || this.UserRole === 'Buero') {
                      <c-dropdown alignment="end">
                        <button
                          class="big-screen-nav-btn"
                          cDropdownToggle
                          type="button"
                          style="border: none; background: transparent; position: relative;"
                          >
                          Aufträge
                        </button>
                        <ul cDropdownMenu>
                          <li>
                            <a (click)="navigateTo('customer-table')" class="dropdown-item">Kunden</a>
                          </li>
                          <li>
                            <a (click)="navigateTo('')" class="dropdown-item">Vorgänge</a>
                          </li>
                        </ul>
                      </c-dropdown>
                    }
                    @if (this.UserRole === 'Admin' || this.UserRole === 'Buero') {
                      <c-dropdown alignment="end">
                        <button
                          class="big-screen-nav-btn"
                          cDropdownToggle
                          type="button"
                          style="border: none; background: transparent; position: relative;"
                          >
                          Abrechnung
                        </button>
                        <ul cDropdownMenu>
                          <li>
                            <a (click)="navigateTo('termin-sortierung')" class="dropdown-item">Termin Sortierung</a>
                          </li>
                          <!-- <li>
                          <a (click)="navigateTo('termin-filter')" class="dropdown-item">Termin Filter</a>
                        </li>
                        <li>
                          <a (click)="navigateTo('search-event-view')" class="dropdown-item">Termin-Suche</a>
                        </li> -->
                      </ul>
                    </c-dropdown>
                  }
                  @if (this.UserRole === 'Admin' || this.UserRole === 'Dolmetscher') {
                    <c-dropdown alignment="end">
                      <button
                        class="big-screen-nav-btn"
                        cDropdownToggle
                        type="button"
                        style="border: none; background: transparent; position: relative;"
                        >
                        Dolmetscher
                      </button>
                      <ul cDropdownMenu>
                        <li>
                          <a (click)="navigateTo('timesheet')" class="dropdown-item">Stundenliste</a>
                        </li>
                        <li>
                          <a (click)="navigateTo('interpreter')" class="dropdown-item">Kalender</a>
                        </li>
                      </ul>
                    </c-dropdown>
                  }
                </c-header-nav>
              }

            </div>

          </div>

          @if (smallTabView) {
            <div>
              <app-menu-sidebar [isVisible]="isSidebarVisible" (closeSidebar)="toggleSidebar()"></app-menu-sidebar>
            </div>
          }
        </header>


        <!-- Event Filter Popup Component -->
        <app-filter-event-popup
          [listEvents]="listEvents"
          [originalEvents]="originalEvents"
          (filteredEventChange)="onFilteredEventChange($event)">
        </app-filter-event-popup>


        <!-- Event Search Results -->
        @if (displayResults) {
          <div (click)="onWrapperClick($event)" class="resizable-event-wrapper">
            <div class="resizable-event-container" [ngStyle]="{ height: eventListHeight + 'px' }">
              <div class="event-scroll-wrapper">
                <mbsc-eventcalendar
                  [data]="listEvents"
                  [showControls]="false"
                  [view]="listView"
                  (onEventClick)="onEventClick($event)"
                  class="event-list"
                  [eventTemplate]="eventTemp">
                  <ng-template #eventTemp let-event>
                    <app-event-view-search [event]="event" [dragging]="dragging"></app-event-view-search>
                  </ng-template>
                </mbsc-eventcalendar>
              </div>
              <div class="resize-handle-vertical" (mousedown)="startResize($event)"></div>
            </div>
          </div>
        }